module.exports = __webpack_public_path__ + "static/media/lp-img-3.b744af2a.png";